module.exports = "/images/oculus-1.jpg";